/* LABEL R S — Boutique JS v35
   - NOTIFY ME: floating bar now detects when the selected variant
     is sold out and swaps the ATC+Buy-Now row for a Notify-Me
     button. Tapping it expands an inline email form; submitting
     sends a contact-form request to the store owner with the
     product title, variant name, and page URL. Shows a branded
     success/error confirmation inline — no page reload.
   - Curtain: sessionStorage-only (no 48-hr cookie). */
(function () {
  'use strict';
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var isProductPage = /\/products\//.test(window.location.pathname);
  var LION = (window.LRS_LION_URL || '');

  var lrsCartCount = null;

  function setAllBadgeCounts(n) {
    n = parseInt(n, 10) || 0;
    lrsCartCount = n;
    var text = n > 99 ? '99+' : String(n);
    document.querySelectorAll('.lrs-bn-badge:not(.lrs-wl-nav-badge)').forEach(function (b) {
      b.textContent = text;
      b.style.display = n > 0 ? 'flex' : 'none';
    });
    document.querySelectorAll('.cart-bubble').forEach(function (bubble) {
      var countEl = bubble.querySelector('.cart-bubble__text-count');
      if (countEl) {
        countEl.textContent = n > 0 ? text : '';
        countEl.classList.toggle('hidden', n === 0);
      }
      bubble.classList.toggle('visually-hidden', n === 0);
    });
    document.querySelectorAll('.header-actions__cart-icon').forEach(function (icon) {
      icon.classList.toggle('header-actions__cart-icon--has-cart', n > 0);
    });
  }

  function optimisticBump(delta) {
    if (lrsCartCount === null) return;
    setAllBadgeCounts(lrsCartCount + delta);
  }

  function getHeaderSectionId() {
    var headerSectionEl = document.querySelector('.header-section');
    if (!headerSectionEl || !headerSectionEl.id) return null;
    return { el: headerSectionEl, id: headerSectionEl.id.replace('shopify-section-', '') };
  }

  function refreshCartEverything() {
    var ref = getHeaderSectionId();
    if (!ref) return;
    fetch('/?sections=' + encodeURIComponent(ref.id), { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var html = data && data[ref.id];
        if (!html) return;
        var temp = document.createElement('div');
        temp.innerHTML = html;
        var trueCount = 0;
        var freshBubbles = temp.querySelectorAll('.cart-bubble');
        var liveBubbles = ref.el.querySelectorAll('.cart-bubble');
        liveBubbles.forEach(function (liveBubble, i) {
          var fresh = freshBubbles[i];
          if (!fresh) return;
          var c = fresh.querySelector('.cart-bubble__text-count');
          if (c) { var n = parseInt(c.textContent, 10); if (!isNaN(n)) trueCount = Math.max(trueCount, n); }
        });
        var dialog = document.querySelector('dialog.cart-drawer__dialog');
        if (dialog) {
          var freshDialog = temp.querySelector('dialog.cart-drawer__dialog');
          var freshInner = temp.querySelector('.cart-drawer__inner');
          var liveInner = dialog.querySelector('.cart-drawer__inner');
          if (freshInner && liveInner) liveInner.innerHTML = freshInner.innerHTML;
          if (freshDialog) dialog.classList.toggle('cart-drawer--empty', freshDialog.classList.contains('cart-drawer--empty'));
        }
        setAllBadgeCounts(trueCount);
      })
      .catch(function () {});
  }

  (function installFetchHook() {
    if (window.__lrsFetchHooked) return;
    window.__lrsFetchHooked = true;
    var originalFetch = window.fetch;
    window.fetch = function (input, init) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var method = ((init && init.method) || (typeof input !== 'string' && input && input.method) || 'GET').toUpperCase();
      var isAdd = method === 'POST' && /\/cart\/add(\.js)?(\?|$)/.test(url);
      var promise = originalFetch.apply(this, arguments);
      if (isAdd) {
        promise.then(function (res) {
          if (!res || !res.ok) return;
          res.clone().json().then(function (data) {
            if (data && data.status) return;
            var items = Array.isArray(data) ? data : (data && data.items) ? data.items : [data];
            var totalQty = items.reduce(function (sum, it) { return sum + ((it && it.quantity) || 1); }, 0) || 1;
            optimisticBump(totalQty);
            refreshCartEverything();
          }).catch(function () { refreshCartEverything(); });
        }).catch(function () {});
      }
      return promise;
    };
  })();

  function looksLikeEmptyCartUI() {
    if (document.getElementById('cart-drawer-heading-empty')) return true;
    var heads = document.querySelectorAll('h1, h2');
    for (var i = 0; i < heads.length; i++) {
      if (/your cart is empty/i.test(heads[i].textContent || '')) return true;
    }
    return false;
  }

  function ensureCartConsistency() {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        setAllBadgeCounts(cart.item_count);
        var GUARD = 'lrs_cart_reload_guard';
        if (cart.item_count > 0 && looksLikeEmptyCartUI()) {
          var already = false;
          try { already = sessionStorage.getItem(GUARD) === '1'; } catch (e) {}
          if (!already) {
            try { sessionStorage.setItem(GUARD, '1'); } catch (e) {}
            location.reload();
          }
        } else {
          try { sessionStorage.removeItem(GUARD); } catch (e) {}
        }
      })
      .catch(function () {});
  }

  /* CURTAIN — sessionStorage only */
  function hasSeen() {
    try { return sessionStorage.getItem('lrs-curtain-seen') === '1'; } catch (e) {}
    return false;
  }
  function markSeen() {
    try { sessionStorage.setItem('lrs-curtain-seen', '1'); } catch (e) {}
  }
  function initCurtain() {
    var c = document.getElementById('lrs-curtain');
    if (!c || reduceMotion) return;
    if (isProductPage) { c.remove(); return; }
    if (hasSeen()) return;
    markSeen();
    c.classList.add('lrs-curtain--active');
    setTimeout(function () { c.classList.add('lrs-curtain--open'); }, 1300);
    setTimeout(function () { c.classList.add('lrs-curtain--done'); }, 2200);
  }

  /* SCROLL REVEALS */
  function initReveals() {
    if (reduceMotion || !('IntersectionObserver' in window)) return;
    var main = document.getElementById('MainContent');
    if (!main) return;
    var sections = main.querySelectorAll('.shopify-section');
    var targets = [];
    sections.forEach(function (s) {
      var cards = s.querySelectorAll('.product-card, .resource-card');
      if (cards.length > 1) cards.forEach(function (c, i) { c.classList.add('lrs-reveal'); c.style.setProperty('--lrs-d', String(Math.min(i % 8, 6))); targets.push(c); });
      if (s !== sections[0]) { s.classList.add('lrs-reveal'); targets.push(s); }
    });
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('lrs-in'); obs.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
    targets.forEach(function (t) { if (t.getBoundingClientRect().top < window.innerHeight * 0.9) t.classList.add('lrs-in'); else obs.observe(t); });
  }

  /* MOBILE MENU DRAWER LION */
  function injectDrawerBrand() {
    if (!LION) return;
    document.querySelectorAll('.menu-drawer').forEach(function (drawer) {
      if (drawer.querySelector('.menu-drawer__brand')) return;
      var brand = document.createElement('div'); brand.className = 'menu-drawer__brand';
      brand.innerHTML = '<img src="' + LION + '" alt="Label RS" width="160"><span class="menu-drawer__brand-rule"></span>';
      var anchor = drawer.querySelector('.menu-drawer__inner, .menu-drawer__navigation, nav, ul');
      if (anchor && anchor.parentNode) anchor.parentNode.insertBefore(brand, anchor);
      else drawer.insertBefore(brand, drawer.firstChild);
    });
  }

  function initCartDrawerReliableClose() {
    document.addEventListener('click', function (e) {
      var closeBtn = e.target.closest('.cart-drawer__close-button');
      if (closeBtn) {
        var dlg = closeBtn.closest('dialog.cart-drawer__dialog');
        if (dlg && dlg.open) dlg.close();
        return;
      }
      var backdrop = e.target.closest && e.target.closest('dialog.cart-drawer__dialog');
      if (backdrop && e.target === backdrop && typeof backdrop.close === 'function') backdrop.close();
    }, true);
  }

  function initCartDrawerOpenWatcher() {
    document.addEventListener('click', function (e) {
      var trigger = e.target.closest('[data-testid="cart-drawer-trigger"]');
      if (!trigger) return;
      refreshCartEverything();
    }, true);
  }

  function initBottomNav() {
    var nav = document.querySelector('.lrs-bottom-nav');
    if (nav) {
      var path = window.location.pathname.replace(/\/$/, '') || '/';
      nav.querySelectorAll('a[data-path]').forEach(function (a) {
        var p = a.getAttribute('data-path').replace(/\/$/, '') || '/';
        if (p === '/' ? path === '/' : path.indexOf(p) === 0) a.classList.add('lrs-bn-active');
      });
    }
    ensureCartConsistency();
    window.addEventListener('pageshow', function (e) { if (e.persisted) ensureCartConsistency(); });
  }

  function initShopMenuTrigger() {
    document.addEventListener('click', function (e) {
      var link = e.target.closest('.lrs-bn-menu-trigger');
      if (!link) return;
      e.preventDefault();
      var toggle =
        document.querySelector('button[aria-controls*="menu"]') ||
        document.querySelector('button[aria-controls*="drawer"]') ||
        document.querySelector('.header__icon--menu') ||
        document.querySelector('header-component summary') ||
        document.querySelector('summary.header__icon');
      if (toggle) toggle.click();
      else window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  }

  /* BADGES */
  var BADGE_TAGS = [
    { tag: 'best-seller', label: '\u2605 Best Seller', cls: 'lrs-badge--bestseller' },
    { tag: 'bestseller',  label: '\u2605 Best Seller', cls: 'lrs-badge--bestseller' },
    { tag: 'new-arrival', label: 'New',            cls: 'lrs-badge--new' },
    { tag: 'trending',    label: '\uD83D\uDD25 Trending', cls: 'lrs-badge--trending' }
  ];
  var lrsProductTagCache = window.__lrsProductTagCache = window.__lrsProductTagCache || {};
  var lrsBadgeQueue = [];
  var lrsBadgeInFlight = 0;
  var LRS_BADGE_CONCURRENCY = 4;

  function lrsRunBadgeQueue() {
    while (lrsBadgeInFlight < LRS_BADGE_CONCURRENCY && lrsBadgeQueue.length) {
      var job = lrsBadgeQueue.shift();
      lrsBadgeInFlight++;
      job(function () { lrsBadgeInFlight--; lrsRunBadgeQueue(); });
    }
  }

  function applyBadgesToCard(card, ptags) {
    var matches = BADGE_TAGS.filter(function (b) { return ptags.indexOf(b.tag) !== -1; });
    if (!matches.length) return;
    var wrap = card.querySelector('figure, .card__media, [class*="gallery"], [class*="image"]') || card;
    wrap.style.position = 'relative';
    var stack = wrap.querySelector('.lrs-badge-stack');
    if (!stack) {
      stack = document.createElement('div');
      stack.className = 'lrs-badge-stack';
      wrap.appendChild(stack);
    }
    matches.forEach(function (b) {
      if (stack.querySelector('.' + b.cls)) return;
      var el = document.createElement('span'); el.className = 'lrs-badge ' + b.cls; el.textContent = b.label;
      stack.appendChild(el);
    });
  }

  function injectBadges(root) {
    root = root || document;
    root.querySelectorAll('.product-card:not([data-lb-done]), product-card:not([data-lb-done])').forEach(function (card) {
      card.setAttribute('data-lb-done', '1');
      var link = card.querySelector('a[href*="/products/"]'); if (!link) return;
      var m = (link.pathname || '').match(/\/products\/([^/?#]+)/);
      if (!m || /^\d+$/.test(m[1])) return;
      var handle = m[1];
      if (lrsProductTagCache[handle]) { applyBadgesToCard(card, lrsProductTagCache[handle]); return; }
      if (lrsProductTagCache[handle] === null) return;
      lrsBadgeQueue.push(function (done) {
        fetch('/products/' + handle + '.js')
          .then(function (r) { return r.ok ? r.json() : null; })
          .then(function (p) {
            var ptags = p ? (p.tags || []).map(function (t) { return t.toLowerCase().replace(/\s+/g, '-'); }) : [];
            lrsProductTagCache[handle] = p ? ptags : null;
            if (p) applyBadgesToCard(card, ptags);
          })
          .catch(function () { lrsProductTagCache[handle] = null; })
          .finally(done);
      });
    });
    lrsRunBadgeQueue();
  }

  /* LUXURY VARIANT CIRCLES */
  function initVariantCircles() {
    if (!isProductPage) return;
    function syncLabel(label) {
      var input = label.querySelector('input[type="radio"]');
      if (!input) return;
      label.classList.toggle('lrs-active', input.checked);
      label.classList.toggle('lrs-disabled', input.getAttribute('aria-disabled') === 'true');
    }
    function applyAll() {
      document.querySelectorAll('.variant-option__button-label').forEach(function (label) {
        syncLabel(label);
        if (label.getAttribute('data-lrs-bound')) return;
        label.setAttribute('data-lrs-bound', '1');
        var input = label.querySelector('input[type="radio"]');
        if (!input) return;
        input.addEventListener('change', function () {
          var fieldset = label.closest('fieldset');
          if (fieldset) fieldset.querySelectorAll('.variant-option__button-label').forEach(function (l) { l.classList.remove('lrs-active'); });
          label.classList.add('lrs-active');
        });
      });
    }
    applyAll(); setTimeout(applyAll, 500); setTimeout(applyAll, 1500);
    document.addEventListener('variant:changed', applyAll);
    document.addEventListener('change', function (e) {
      if (e.target.matches('input[type="radio"]')) setTimeout(applyAll, 50);
    });
  }

  /* ================================================================
     FLOATING BUY BAR
  ================================================================ */
  function initFloatingBuyBar() {
    var bar = document.getElementById('lrs-float-cta');
    if (!bar) return;
    if (bar.getAttribute('data-lrs-wired')) return;
    bar.setAttribute('data-lrs-wired', '1');

    requestAnimationFrame(function () { bar.classList.add('lrs--visible'); });

    /* ----- Variant data map ----- */
    var variantsMap = {};
    (function () {
      var script = bar.querySelector('[data-lrs-variants]');
      if (!script) return;
      try {
        var arr = JSON.parse(script.textContent);
        arr.forEach(function (v) { variantsMap[String(v.id)] = v; });
      } catch (e) {}
    })();

    var saleSpan    = bar.querySelector('.lrs-fcta-price__sale');
    var compareSpan = bar.querySelector('.lrs-fcta-price__compare');
    var badgeSpan   = bar.querySelector('.lrs-fcta-discount-badge');
    var actionsRow  = bar.querySelector('.lrs-fcta-actions-row');
    var notifyWrap  = bar.querySelector('.lrs-fcta-notify');

    /* ----- Toggle between ATC/Buy and Notify Me ----- */
    function showAvailable() {
      if (actionsRow) actionsRow.style.display = 'flex';
      if (notifyWrap) notifyWrap.style.display = 'none';
      bar.removeAttribute('data-sold-out');
    }
    function showSoldOut() {
      if (actionsRow) actionsRow.style.display = 'none';
      if (notifyWrap) notifyWrap.style.display = 'block';
      bar.setAttribute('data-sold-out', '1');
    }

    /* ----- Apply variant data to the bar ----- */
    function applyVariant(variantId) {
      var v = variantsMap[String(variantId)];
      if (!v) return;
      bar.setAttribute('data-variant-id', variantId);
      if (saleSpan) saleSpan.textContent = v.sale;
      if (compareSpan) {
        if (v.compare) { compareSpan.textContent = v.compare; compareSpan.style.display = ''; }
        else { compareSpan.style.display = 'none'; }
      }
      if (badgeSpan) {
        if (v.pct) { badgeSpan.textContent = v.pct + '% OFF'; badgeSpan.style.display = ''; }
        else { badgeSpan.style.display = 'none'; }
      }
      /* Toggle Notify Me based on availability */
      if (v.available === false) showSoldOut();
      else showAvailable();
    }

    /* Apply initial state from data attribute */
    (function () {
      var initAvail = bar.getAttribute('data-variant-available');
      if (initAvail === 'false') showSoldOut();
    })();

    /* Sync when page-level variant changes */
    document.addEventListener('change', function (e) {
      var input = e.target;
      if (!(input.matches && input.matches('.variant-option__button-label input[type="radio"]'))) return;
      var vid = input.getAttribute('data-variant-id');
      if (vid) applyVariant(vid);
    });
    document.addEventListener('variant:changed', function (e) {
      var vid = e && e.detail && e.detail.variant && e.detail.variant.id;
      if (vid) applyVariant(String(vid));
    });

    /* ----- MID ROW: dropdown + qty ----- */
    function getOrCreateMidRow() {
      var existing = bar.querySelector('.lrs-fcta-mid-row');
      if (existing) return existing;
      var row = document.createElement('div');
      row.className = 'lrs-fcta-mid-row';
      var divider = bar.querySelector('.lrs-fcta-divider-h');
      if (divider && divider.parentNode) divider.parentNode.insertBefore(row, divider.nextSibling);
      return row;
    }

    function isColourFieldset(fs) {
      var legend = fs.querySelector('legend');
      if (legend) {
        var lt = legend.textContent.trim().toLowerCase();
        if (lt.indexOf('color') !== -1 || lt.indexOf('colour') !== -1) return true;
      }
      var labels = fs.querySelectorAll('.variant-option__button-label');
      for (var i = 0; i < labels.length; i++) {
        var styled = labels[i].querySelectorAll('[style]');
        for (var j = 0; j < styled.length; j++) {
          if ((styled[j].getAttribute('style') || '').indexOf('background') !== -1) return true;
        }
      }
      return false;
    }

    function injectVariantDropdown(midRow) {
      if (midRow.querySelector('.lrs-fcta-select-wrap')) return;
      var fieldsets = document.querySelectorAll('main .variant-option--buttons, #MainContent .variant-option--buttons');
      if (!fieldsets.length) return;

      fieldsets.forEach(function (fs) {
        if (isColourFieldset(fs)) return;
        var inputs = Array.prototype.slice.call(fs.querySelectorAll('input[type="radio"]'));
        if (!inputs.length) return;
        var legend = fs.querySelector('legend');
        var labelText = legend ? legend.textContent.trim().split(/\s{2,}/)[0] : 'Size';

        var wrap = document.createElement('div');
        wrap.className = 'lrs-fcta-select-wrap';
        var select = document.createElement('select');
        select.className = 'lrs-fcta-select';
        select.setAttribute('aria-label', 'Select ' + labelText);

        inputs.forEach(function (input, idx) {
          var lbl = input.closest('.variant-option__button-label');
          var textEl = lbl ? lbl.querySelector('.variant-option__button-label__text') : null;
          var sizeText = textEl ? textEl.textContent.trim() : (input.value || 'Option ' + (idx + 1));
          var disabled = input.getAttribute('aria-disabled') === 'true' || !!input.disabled;
          var opt = document.createElement('option');
          opt.value = String(idx);
          opt.textContent = disabled ? sizeText + ' — Out of stock' : sizeText;
          opt.disabled = disabled;
          if (input.checked) opt.selected = true;
          select.appendChild(opt);
        });

        select.addEventListener('change', function () {
          var idx = parseInt(select.value, 10);
          var input = inputs[idx];
          if (input && !input.checked) {
            input.checked = true;
            input.dispatchEvent(new Event('change', { bubbles: true }));
          }
        });
        inputs.forEach(function (input, idx) {
          input.addEventListener('change', function () {
            if (input.checked && parseInt(select.value, 10) !== idx) select.value = String(idx);
          });
        });
        document.addEventListener('variant:changed', function () {
          inputs.forEach(function (input, idx) {
            if (input.checked && parseInt(select.value, 10) !== idx) select.value = String(idx);
          });
        });

        wrap.appendChild(select);
        midRow.appendChild(wrap);
      });
    }

    function injectQuantityStepper(midRow) {
      if (midRow.querySelector('.lrs-fcta-qty')) return;
      var realInput = document.querySelector('input[name="quantity"]');
      if (!realInput) return;
      var wrap = document.createElement('div');
      wrap.className = 'lrs-fcta-qty';
      wrap.innerHTML =
        '<button type="button" class="lrs-fcta-qty__btn" data-dir="-1" aria-label="Decrease">\u2212</button>' +
        '<span class="lrs-fcta-qty__val">' + (parseInt(realInput.value, 10) || 1) + '</span>' +
        '<button type="button" class="lrs-fcta-qty__btn" data-dir="1" aria-label="Increase">+</button>';
      var valSpan = wrap.querySelector('.lrs-fcta-qty__val');
      function readMin() { var m = parseInt(realInput.getAttribute('min'), 10); return isNaN(m) || m < 1 ? 1 : m; }
      function readMax() { var m = parseInt(realInput.getAttribute('max'), 10); return isNaN(m) ? Infinity : m; }
      function setQty(n) {
        n = Math.max(readMin(), Math.min(readMax(), n));
        if (String(n) === realInput.value && valSpan.textContent === String(n)) return;
        realInput.value = n; valSpan.textContent = n;
        realInput.dispatchEvent(new Event('input', { bubbles: true }));
        realInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
      wrap.querySelectorAll('.lrs-fcta-qty__btn').forEach(function (btn) {
        btn.addEventListener('click', function () { setQty((parseInt(realInput.value, 10) || 1) + parseInt(btn.getAttribute('data-dir'), 10)); });
      });
      realInput.addEventListener('input', function () { valSpan.textContent = parseInt(realInput.value, 10) || 1; });
      realInput.addEventListener('change', function () { valSpan.textContent = parseInt(realInput.value, 10) || 1; });
      midRow.appendChild(wrap);
    }

    var midRow = getOrCreateMidRow();
    injectVariantDropdown(midRow);
    injectQuantityStepper(midRow);

    /* ================================================================
       NOTIFY ME — email form that submits via Shopify contact form.
       Store owner receives an email with the product + variant info.
    ================================================================ */
    function initNotifyMe() {
      if (!notifyWrap) return;
      var notifyBtn    = notifyWrap.querySelector('.lrs-fcta-notify-btn');
      var notifyForm   = notifyWrap.querySelector('.lrs-fcta-notify-form');
      var emailInput   = notifyWrap.querySelector('.lrs-fcta-notify-email');
      var submitBtn    = notifyWrap.querySelector('.lrs-fcta-notify-submit');
      var successMsg   = notifyWrap.querySelector('.lrs-fcta-notify-success');
      var submitSpan   = submitBtn ? submitBtn.querySelector('span') : null;

      if (!notifyBtn || !notifyForm || !emailInput || !submitBtn) return;

      /* Toggle form open/close */
      notifyBtn.addEventListener('click', function () {
        var isOpen = notifyForm.style.display !== 'none';
        notifyForm.style.display = isOpen ? 'none' : 'flex';
        if (!isOpen) {
          emailInput.focus();
          if (successMsg) successMsg.style.display = 'none';
        }
      });

      /* Submit notification request */
      submitBtn.addEventListener('click', function () {
        var email = emailInput.value.trim();
        if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
          emailInput.classList.add('lrs-fcta-notify-email--error');
          emailInput.focus();
          return;
        }
        emailInput.classList.remove('lrs-fcta-notify-email--error');

        var productTitle = bar.getAttribute('data-product-title') || document.title;
        var variantId    = bar.getAttribute('data-variant-id');
        var variantData  = variantsMap[variantId] || {};
        var variantTitle = variantData.title || variantId;

        if (submitSpan) submitSpan.textContent = 'Sending\u2026';
        submitBtn.disabled = true;

        var body =
          'Back-in-stock notification request' +
          '\n\nProduct: ' + productTitle +
          '\nVariant: ' + variantTitle +
          '\nVariant ID: ' + variantId +
          '\nPage: ' + window.location.href +
          '\nCustomer email: ' + email;

        var fd = new FormData();
        fd.append('form_type', 'contact');
        fd.append('utf8', '\u2713');
        fd.append('contact[email]', email);
        fd.append('contact[name]', 'Back in Stock Request');
        fd.append('contact[body]', body);

        fetch('/contact', { method: 'POST', body: fd })
          .then(function () {
            notifyForm.style.display = 'none';
            if (successMsg) successMsg.style.display = 'flex';
            emailInput.value = '';
          })
          .catch(function () {
            /* Fallback: redirect to contact page */
            window.location.href = '/pages/contact';
          })
          .finally(function () {
            submitBtn.disabled = false;
            if (submitSpan) submitSpan.textContent = 'Notify Me';
          });
      });

      /* Allow Enter key in email field */
      emailInput.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') submitBtn.click();
        emailInput.classList.remove('lrs-fcta-notify-email--error');
      });
    }
    initNotifyMe();

    /* ----- ATC / Buy Now ----- */
    function getForm() {
      return document.querySelector('form[action="/cart/add"], form[action*="/cart/add"], product-form form');
    }
    function getQuantity() {
      var input = document.querySelector('input[name="quantity"]');
      var val = input ? parseInt(input.value, 10) : 1;
      return (val && val > 0) ? val : 1;
    }
    function getCurrentVariantId() {
      var checked = document.querySelector('.variant-option__button-label input[type="radio"]:checked[data-variant-id]');
      if (checked) return checked.getAttribute('data-variant-id');
      return bar.getAttribute('data-variant-id');
    }

    function ajaxAddToCart(onDone) {
      var form = getForm();
      var req;
      if (form) {
        var fd = new FormData(form);
        req = fetch('/cart/add.js', { method: 'POST', body: fd, headers: { Accept: 'application/json' } });
      } else {
        var variantId = getCurrentVariantId();
        if (!variantId) { onDone(new Error('No variant selected')); return; }
        req = fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: getQuantity() })
        });
      }
      req.then(function (r) { return r.json(); })
        .then(function (data) {
          if (data && data.status) { onDone(new Error(data.description || 'Error')); return; }
          onDone(null, data);
        })
        .catch(function (err) { onDone(err); });
    }

    function goToStandardCheckout() {
      var form = document.createElement('form');
      form.method = 'post'; form.action = '/cart'; form.style.display = 'none';
      var input = document.createElement('input');
      input.type = 'submit'; input.name = 'checkout'; input.value = 'Checkout';
      form.appendChild(input); document.body.appendChild(form); form.submit();
    }

    function runBuyNowAction() {
      var action = bar.getAttribute('data-buy-action') || 'cart_checkout';
      var selector = bar.getAttribute('data-buy-selector') || '';
      var url = bar.getAttribute('data-buy-url') || '';
      if (action === 'click_selector' && selector) { var target = document.querySelector(selector); if (target) { target.click(); return; } }
      if (action === 'custom_url' && url) { window.location.href = url; return; }
      goToStandardCheckout();
    }

    var atcBtn = bar.querySelector('.lrs-fcta-atc');
    if (atcBtn) {
      atcBtn.addEventListener('click', function () {
        if (atcBtn.disabled) return;
        var span = atcBtn.querySelector('span'), orig = span.textContent;
        atcBtn.disabled = true; atcBtn.classList.add('lrs--loading'); span.textContent = 'Adding\u2026';
        ajaxAddToCart(function (err) {
          atcBtn.classList.remove('lrs--loading');
          if (err) {
            atcBtn.classList.add('lrs--error'); span.textContent = 'Try again';
            setTimeout(function () { atcBtn.classList.remove('lrs--error'); span.textContent = orig; atcBtn.disabled = false; }, 1500);
          } else {
            atcBtn.classList.add('lrs--success'); span.textContent = '\u2713 Added!';
            setTimeout(function () { atcBtn.classList.remove('lrs--success'); span.textContent = orig; atcBtn.disabled = false; }, 1300);
          }
        });
      });
    }

    var buyBtn = bar.querySelector('.lrs-fcta-buy');
    if (buyBtn) {
      buyBtn.addEventListener('click', function () {
        if (buyBtn.disabled) return;
        var span = buyBtn.querySelector('span'), orig = span.textContent;
        buyBtn.disabled = true; buyBtn.classList.add('lrs--loading'); span.textContent = 'Redirecting\u2026';
        ajaxAddToCart(function (err) {
          if (err) { buyBtn.classList.remove('lrs--loading'); span.textContent = orig; buyBtn.disabled = false; return; }
          runBuyNowAction();
        });
      });
    }
  }

  /* MUTATION OBSERVER */
  function watchMutations() {
    if (!window.MutationObserver) return;
    var pendingNodes = [];
    var timer;
    new MutationObserver(function (mutations) {
      mutations.forEach(function (m) {
        m.addedNodes.forEach(function (n) { if (n.nodeType === 1) pendingNodes.push(n); });
      });
      if (!pendingNodes.length) return;
      clearTimeout(timer);
      timer = setTimeout(function () {
        var nodes = pendingNodes; pendingNodes = [];
        injectDrawerBrand();
        nodes.forEach(function (n) { injectBadges(n); });
      }, 150);
    }).observe(document.body, { childList: true, subtree: true });
  }

  function init() {
    initFloatingBuyBar();
    initCurtain();
    injectDrawerBrand();
    initBottomNav();
    initCartDrawerReliableClose();
    initCartDrawerOpenWatcher();
    initShopMenuTrigger();
    initVariantCircles();
    injectBadges();
    initReveals();
    watchMutations();
    document.addEventListener('click', function (e) {
      if (e.target.closest('[aria-controls], .header__icon, summary, .menu-drawer__toggle'))
        setTimeout(injectDrawerBrand, 80);
    }, true);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
